export default __webpack_public_path__ + "static/media/search.af4f0c59.svg";